import actions from './actions';

export default (app) => ({
  namespaced: true,
  actions: actions(app),
});
